import { Schedule } from 'sr-types/lib/resource/v1/graphql';
import { Resource } from 'sr-types/lib/search/v1/graphql';
import { StepsIndexConstant } from '../../common/components/Stepper';
import { resourceServiceDataToPreview } from '../resourceUtils';
import { RESOURCE_FIELD_NAMES } from '../common/resourceConstants';
import { isEmpty } from 'lodash';

export type ResourceStepperDataType = {
    type: string;
    values: Object;
    resourceSchedule: Schedule;
    selectedTemplateId: string;
};

export const getResourceDataAndTypeStepStates = (
    resource: Resource,
    currentSelectedId: string,
    currentState: Resource
) => {
    const isDeselect = resource.id === currentSelectedId;
    const values = isDeselect ? null : resourceServiceDataToPreview(resource);

    const data: ResourceStepperDataType = {
        type: isDeselect ? currentState.type : values.type,
        values,
        resourceSchedule: values?.resourceSchedule || null,
        selectedTemplateId: isDeselect ? null : resource.id
    };
    const states = {
        selectedId: isDeselect ? null : resource.id,
        isCreateBlankActivated: isDeselect,
        isTemplateActivated: !isDeselect
    };

    return { data, states };
};

export const createResourceStepperExistingData = (
    { type, values, resourceSchedule, selectedTemplateId = null },
    isHireResource = false
) => {
    const { location, locations, ...resourceDetails } = values || {}; //If the resource data comes from the search it'll have location field, otherwise the field is called locations / check ResourceInput in sr-types for details
    const { timezone, ...locationsData } = location || {};
    const resLocation = !isEmpty(locationsData) ? locationsData : locations;
    const updatedStepData = [
        { step: StepsIndexConstant.zero, values: { type, selectedTemplateId } },
        {
            step: StepsIndexConstant.one,
            values: !isEmpty(resLocation)
                ? {
                      ...resourceDetails,
                      [RESOURCE_FIELD_NAMES.locations]: resLocation
                  }
                : values
        }
    ];

    return [...updatedStepData, ...(isHireResource ? [] : [{ step: StepsIndexConstant.two, values: { resourceSchedule } }])];
};
